export default __webpack_public_path__ + "static/Satoshi-Medium-subset-af6fc285e6a524af43f7c6de1620bdef.woff2";